__turbopack_context__.v({
  "small": "Oz9I4q_small",
  "ticket": "Oz9I4q_ticket",
  "ticket1": "Oz9I4q_ticket1",
  "ticket2": "Oz9I4q_ticket2",
  "ticketLabel": "Oz9I4q_ticketLabel",
  "ticketLink": "Oz9I4q_ticketLink",
  "tickets": "Oz9I4q_tickets",
});
